//------------------------------------------------------------------------------
// 地図部品 ポップアップ
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import CustomContent from '@arcgis/core/popup/content/CustomContent';
import PopupTemplate from '@arcgis/core/PopupTemplate';

/**
 * 地図ポップアップ フック
 */
export function usePopupPortal(getTitle) {

  // 状態
  const [ container, setContainer ] = React.useState(null);
  const [ attribute, setAttribute ] = React.useState(null);

  // タイトル
  const title = React.useCallback((event) => {

    // タイトル取得
    const attr = event.graphic?.attributes ?? {};
    const title = getTitle(attr ?? {});

    // タイトル要素 (または配列)
    return Array.isArray(title)
        ? title.join('<br/>')
        : title;
  }, [getTitle]);

  // ポップアップ要素
  const content = React.useMemo(() => new CustomContent({
    creator: (event) => {

      // 地図の属性を状態に保存
      const attr = event.graphic?.attributes ?? {};
      setAttribute(attr);

      // DOMを作成して状態に保存
      const div = document.createElement('div');
      setContainer(div);
      return div;
    },
  }), []);

  // テンプレート作成
  const template = React.useMemo(() => new PopupTemplate({
    title: title,
    content: [ content ],
  }), [ title, content ]);

  // ポップアップ情報を返す
  return {
    template,
    container,
    attribute,
  };
}

/*
 * 地図ポップアップ ポータル
 */
export function PopupPortal({
  container,
  children,
}) {
  return container
      ? createPortal(children, container)
      : null;
}

// プロパティ
PopupPortal.propTypes = {
  container: PropTypes.instanceOf(Element),    // コンテナ
  children: PropTypes.node,                    // 子要素
};
